import React, { useState, useEffect, useRef } from 'react';
import './Navbar.css';
import { FaBars, FaTimes, FaChevronDown, FaDumbbell, FaRunning } from 'react-icons/fa'; 
import { Link } from 'react-router-dom';
import logo from '../assets/logo.svg';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(null); 
  const [activeItem, setActiveItem] = useState(null);
  const navbarRef = useRef(null);
  const [showAppIcons, setShowAppIcons] = useState(false);

  // Close dropdowns on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navbarRef.current && !navbarRef.current.contains(event.target)) {
        setDropdownOpen(null);
        setMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Close dropdowns on navigation
  const closeMobileMenu = () => {
    setMenuOpen(false);
    setDropdownOpen(null);
  };

  const toggleMobileMenu = () => {
    setMenuOpen(!menuOpen);
    setDropdownOpen(null);
  };

  const handleItemClick = (item, index = null) => {
    setActiveItem(prev => {
      if (prev === item) {
        setDropdownOpen(null);
        return null;
      } else {
        setDropdownOpen(index);
        return item;
      }
    });
  };

  return (
    <nav className="navbar" ref={navbarRef}>
      <div className="navbar-container">
        <img 
          src={logo} 
          alt="Aikyam Sports Science Logo" 
          className="logo"
        />

        <ul className={menuOpen ? 'nav-menu active' : 'nav-menu'}>
          <li className={`nav-item ${activeItem === "home" ? "selected" : ""}`}>
            <Link 
              to="/" 
              onClick={() => {
                handleItemClick("home");
                closeMobileMenu();
              }}
            >
              Home
            </Link>
          </li>
          
          <li
            className={`nav-item dropdown ${activeItem === "programs" ? "selected" : ""} ${dropdownOpen === 1 ? 'active' : ''}`}
            onClick={(e) => {
              e.stopPropagation();
              if (dropdownOpen === 1) {
                setDropdownOpen(null);
                setActiveItem(null);
              } else {
                setDropdownOpen(1);
                setActiveItem("programs");
              }
            }}
            tabIndex={0}
          >
            Programs <FaChevronDown className="dropdown-icon" />
            <ul className="dropdown-menu">
              <li onClick={(e) => e.stopPropagation()}>
                <Link to="/fitness" onClick={closeMobileMenu}>
                  Premium Fitness Services
                </Link>
              </li>
              <li onClick={(e) => e.stopPropagation()}>
                <Link to="/athlete-management-system" onClick={closeMobileMenu}>
                  Athlete Monitoring System
                </Link>
              </li>
              <li onClick={(e) => e.stopPropagation()}>
                <Link to="/membership" onClick={closeMobileMenu}>
                  Membership
                </Link>
              </li>
            </ul>
          </li>

          <li
            className={`nav-item dropdown ${activeItem === "products" ? "selected" : ""} ${dropdownOpen === 2 ? 'active' : ''}`}
            onClick={(e) => {
              e.stopPropagation();
              if (dropdownOpen === 2) {
                setDropdownOpen(null);
                setActiveItem(null);
              } else {
                setDropdownOpen(2);
                setActiveItem("products");
              }
            }}
            tabIndex={0}
          >
            Products <FaChevronDown className="dropdown-icon" />
            <ul className="dropdown-menu">
              <li onClick={(e) => e.stopPropagation()}>
                <Link to="/timing-gates" onClick={closeMobileMenu}>
                  Timing-Gate
                </Link>
              </li>
              <li onClick={(e) => e.stopPropagation()}>
                <span
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowAppIcons((prev) => !prev);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  Aikyam App <FaChevronDown style={{ transform: showAppIcons ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.2s" }} />
                </span>

                {showAppIcons && (
                  <div className="app-icons-container">
                    <a href="https://apps.apple.com/us/app/aikyam-sports/id6757456836" target="_blank" rel="noopener noreferrer">
                      <img src={require("../assets/appleio.jpg")} alt="Download on App Store" className="app-icon"/>
                    </a>
                    <a href="https://play.google.com/store/apps/details?id=com.aikyamsports.app&hl=en_IN" target="_blank" rel="noopener noreferrer">
                      <img src={require("../assets/googleio.png")} alt="Get it on Google Play" className="app-icon"/>
                    </a>
                  </div>
                )}
              </li>
            </ul>
          </li>

          <li
            className={`nav-item dropdown ${activeItem === "more" ? "selected" : ""} ${dropdownOpen === 3 ? 'active' : ''}`}
            onClick={(e) => {
              e.stopPropagation();
              if (dropdownOpen === 3) {
                setDropdownOpen(null);
                setActiveItem(null);
              } else {
                setDropdownOpen(3);
                setActiveItem("more");
              }
            }}
            tabIndex={0}
          >
            More <FaChevronDown className="dropdown-icon" />
            <ul className="dropdown-menu">
              <li onClick={(e) => e.stopPropagation()}>
                <Link to="/contact" onClick={closeMobileMenu}>Contact</Link>
              </li>
              <li onClick={(e) => e.stopPropagation()}>
                <Link to="/about" onClick={closeMobileMenu}>About Us</Link>
              </li>
              <li onClick={(e) => e.stopPropagation()}>
                <Link to="/blog" onClick={closeMobileMenu}>Blog</Link>
              </li>
            </ul>
          </li>
        </ul>

{/* --- Quick Links & Actions right side --- */}

        <div className="right-items">


                     {/* Quick link: AMS */}
          <Link to="/athlete-management-system" onClick={closeMobileMenu} className="top-quick-link" title="Athlete Management System">
            <span className="full-text">AMS <FaRunning className="icon-nudge" /></span>
            <div className="mobile-action-stack">
              <FaRunning className="mobile-icon" />
              <span className="mobile-tiny-text">AMS</span>
            </div>
          </Link>
          
          {/* Quick link: Fitness */}
          <Link to="/fitness" onClick={closeMobileMenu} className="top-quick-link" title="Premium Fitness">
            <span className="full-text">Fitness <FaDumbbell className="icon-nudge" /></span>
            <div className="mobile-action-stack">
              <FaDumbbell className="mobile-icon" />
              <span className="mobile-tiny-text">Fitness</span>
            </div>
          </Link>


          {/* Book Session Button */}
          <Link to="/booking" onClick={closeMobileMenu} className="book-btn-link">
            <button className="book-btn" title="Book a Session">
              <div className="desktop-book-content">
                <img src="/SVG/Hand-Rise.svg" alt="Book session" className="hand-icon" />
                <span className="book-text-desktop">Book a Session</span>
              </div>
              <div className="mobile-action-stack">
                <img src="/SVG/Hand-Rise.svg" alt="Book session" className="hand-icon mobile-hand" />
                <span className="mobile-tiny-text">Book Session</span>
              </div>
            </button>
          </Link>

          <div className="menu-icon" onClick={toggleMobileMenu} aria-label="Toggle navigation menu" role="button">
            {menuOpen ? <FaTimes /> : <FaBars />}
          </div>
        </div>

      </div>
    </nav>
  );
};

export default Navbar;